import React, { useEffect, useRef, useState } from "react";
import {
  InputField,
  Modal,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import styles from "./connec.module.css";
import { Checkbox, List } from "antd";
import { PiSealCheck } from "react-icons/pi";
import { TbDeviceRemote } from "react-icons/tb";
import { PlusCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { AssetsMiddleware } from "../../../../../Store/Middlewares/AssetsMiddleware";
import { useDispatch, useSelector } from "react-redux";
import imagePlaceholder from "../../../../../assets/images/md1.png";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
const ConnectModule = ({
  connectModal,
  setConnectModal,
  details,
  afterDispatch,
  setOpen,
  user,
}) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [isSelected, setIsSelected] = useState(null);
  const [search, setSearch] = useState("");
  const [ro_number, setRoNumber] = useState("");

  const ref = useRef();
  const navigate = useNavigate();
  // console.log("detailsssssssss*******************", details);
  // console.log("isselected", isSelected);
  const modulesData = useSelector(
    (state) => state.AssetsReducer.getUnlinkModules,
  );
  const getModuleData = (name) => {
    dispatch(AssetsMiddleware.getUnlinkModules(name)).then((data) => {});
  };
  const getData = (name) => {
    dispatch(AssetsMiddleware.getUnlinkAssets(name)).then((data) => {});
  };
  useEffect(() => {
    getModuleData();
    getData();
  }, []);

  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      getModuleData(value);
    }, 1000);
  };

  const modules = [
    {
      id: 2,
      title: "Phoenix Immobilizer N16",
      version: "1.0.5",
      img: require("../../../../../assets/images/staticImages/p1.png"),
    },
    {
      id: 6,
      title: "Phoenix Immobilizer N16",
      version: "1.0.5",
      img: require("../../../../../assets/images/staticImages/p1.png"),
    },
    {
      id: 7,
      title: "Phoenix Immobilizer N16",
      version: "1.0.5",
      img: require("../../../../../assets/images/staticImages/p1.png"),
    },
    {
      id: 11,
      title: "Phoenix Immobilizer N16",
      version: "1.0.5",
      img: require("../../../../../assets/images/staticImages/p1.png"),
    },
  ];

  const onConnectModule = () => {
    let userData = {
      assetId: details?.id,
      ro_number,
      // name: details?.name,
      // make: details?.make,
      // model: details?.model,
      // vinNo: details?.vin_no,
      // licenseNo: details?.license_no,
      deviceId: isSelected?.device_id,
      // deviceName: isSelected?.device_name,
    };
    if (isSelected == null) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Can't connect without selected module",
        }),
      );
    } else if (!ro_number) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Ro number is Required!",
        }),
      );
    } else {
      dispatch(AssetsMiddleware.assignAsset(userData)).then((res) => {
        // if (res?.success) {
        setOpen(false);
        getData();
        getModuleData();
        setConnectModal(false);
        setSuccess(true);
        afterDispatch(false);
        setIsSelected(null);
        setRoNumber("");
        // }
      });
    }
  };
  // const onChange = (e) => {
  //   console.log(`checked = ${e.target.checked}`);
  // };

  const renderModule = (item, index) => {
    return (
      <div className={styles.moduleCont}>
        <div className={styles.moduleSubCont}>
          <div>
            <TextComponent text={"#"} className={styles.heading} />
            <TextComponent text={index + 1} className={styles.heading} />
          </div>
          <img
            className={styles.moduleImg}
            src={item.image}
            alt="module image"
          />
          <div>
            <div>
              <TextComponent
                text={item?.device_id || "--"}
                className={styles.heading}
              />
              <div>
                {/* <TextComponent text={"Firmware Version: "} /> */}
                {/* <TextComponent text={item?.version} className={styles.bold} /> */}
              </div>
            </div>
          </div>
        </div>

        <Checkbox
          onChange={() => setIsSelected(item)}
          checked={isSelected?.id == item?.id}
        />
      </div>
    );
  };
  return (
    <>
      <Modal
        open={connectModal}
        onCancel={() => setConnectModal(false)}
        icon={<TbDeviceRemote size={100} />}
        title={"Connect Device"}
        width={"800px"}
        twoButton
        okBtnTitle={"Connect"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setConnectModal(false);
        }}
        onClickOkButton={
          onConnectModule
          //   () => {

          //   setConnectModal(false);
          //   setSuccess(true);
          // }
        }
        btnStyle={{ width: "80%" }}
        // headingClass={styles.modalHeading}
      >
        <div className={styles.mainCont}>
          {/* {!user?.is_owner && ( */}
          <div className={styles.roInput}>
            <InputField
              label={"RO-Number"}
              placeholder={"Write here"}
              value={ro_number}
              onChange={(e) => setRoNumber(e.target.value)}
            />
          </div>
          {/* )} */}

          <SearchInput value={search} onChange={(e) => onSearch(e)} />

          <List dataSource={modulesData} renderItem={renderModule} />
          {/* <TextComponent text={"+4 more"} className={styles.more} /> */}
          {/* <SubmitButton
            leftIcon={<PlusCircleFilled size={25} />}
            title="Add new module"
            btnClass={styles.regModuleBtn}
            onClick={() =>
              navigate("/moduleRegistration", { state: "userModule" })
            }
          /> */}
        </div>
      </Modal>
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Device connected"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </>
  );
};

export default ConnectModule;
